import React, {Component, Fragment} from 'react'
import { Input } from '@driftt/tide'
import KnowledgebaseSuggestions from 'components/KnowledgebaseSuggestions'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setBotConfig } from 'modules/settings/actions'
import { getBotConfigEnabled, getBotDataSource } from 'modules/settings/selectors'
import { Redirect } from 'react-router-dom'
import { hasGates } from 'utils/access'
import { HELP_SKILL_GATE } from 'constants/Settings'

import './style.css'

const KNOWLEDGE_BASE_HELP_DOC_LINK = 'https://help.drift.com/article/knowledge-base-and-help-doc-integrations/'


class BotSettings extends Component {

  updateBotStatus = value => {
    const botConfigPayload = {
      enabled: value,
      botDatasource: this.props.botDatasource
    }

    this.props.setBotConfig(botConfigPayload)
  }

  render() {
    return (
      <div>
        {
          hasGates(HELP_SKILL_GATE) ?
          <Fragment>
            <KnowledgebaseSuggestions/>

            <div className="bot-skills--skill-checkbox-value-container">
              <Input
                onChange={this.updateBotStatus}
                className="bot-skills-checkbox"
                checked={this.props.isBotEnabled}
                type="checkbox"
              />
              <p className="bot-skills--skill-checkbox-value-wrapper">
                Enable Drift’s help skill to automatically share articles from your knowledge base when someone responds to your welcome message.
                <a className="connection-link" rel="noopener noreferrer" href={KNOWLEDGE_BASE_HELP_DOC_LINK} target="_blank"> Learn More</a>
              </p>
            </div>
          </Fragment>

          : <Redirect exact from='/category' to={`/settings/the-basics`}/>
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isBotEnabled: getBotConfigEnabled(state),
  botDatasource: getBotDataSource(state),
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setBotConfig
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(BotSettings)
